import { call, put, takeEvery } from "redux-saga/effects";
import { feedbackApi } from "../../api/apiService";
import { feedbackRequest, feedbackSuccess, feedbackFailure } from "../slice/feedbackSlice";

export function* submitFeedback(action: { payload: any }): Generator<any, void, any> {
    try {
        const response = yield call(feedbackApi, action.payload);
        if (response.status === 200 || response.status === 201) {
            yield put(feedbackSuccess());
        } else {
            yield put(feedbackFailure("Unexpected response from server"));
        }
    } catch (error: any) {
        yield put(feedbackFailure(error.message || "An unknown error occurred."));
    }
}

export function* feedbackSaga() {
    yield takeEvery(feedbackRequest, submitFeedback);
}
